import gql from 'graphql-tag';

export const ORDER_LOOKUP = gql`
	query OrderLookup($orderNumber: Int!, $zipCode: String!, $token: String!, $email: String, $phone: String) {
		orderLookup(orderNumber: $orderNumber, zipCode: $zipCode, token: $token, email: $email, phone: $phone) {
			... on OrderLookup {
				orderNumber
				isMarketplaceOrder
			}
			... on NotFoundError {
				message
			}
		}
	}
`;
